// Indicadores de la sección "Indicadores Generales", en el orden que devuelve el backend.
export function generalIndicators(state) {
    return state.permissions.filter(p => p.section === 'general')
}

// Indicadores de la sección "Indicadores de Venta".
export function salesIndicators(state) {
    return state.permissions.filter(p => p.section === 'sales')
}



// WEBPACK FOOTER //
// ./src/modules/role-dashboard-permissions/getters.js